import type { ScenarioWorkspaceItemPanel } from '../../model/types'

import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import {
	Tabs,
	TabsContent,
	TabsList,
	TabsTrigger,
} from '@/shared/components/ui/tabs'
import { ampli } from '@/shared/lib/ampli'

import { usePanelController } from '../ScenariosProvider'
import { ScenarioPricingCampaignTab } from './ScenarioPricingCampaignTab'
import { ScenarioPricingCampaignToolbar } from './ScenarioPricingCampaignToolbar'
import { ScenarioSettingsTab } from './ScenarioSettingsTab'

export const ScenarioItemPanel = ({
	panel,
}: {
	panel: ScenarioWorkspaceItemPanel
}) => {
	const { t } = useTranslation()

	const { updatePanel } = usePanelController(panel.id)
	const handleTabChange = useCallback(
		(part: string) => {
			ampli.scenariosSelectTab({
				tab: part,
			})
			updatePanel({
				part: part as 'settings' | 'pricing_campaigns' | undefined,
			})
		},
		[updatePanel]
	)

	return (
		panel.scenarioId && (
			<Tabs
				value={panel.part}
				onValueChange={handleTabChange}
				defaultValue='settings'
				className='flex w-full flex-1 flex-col overflow-y-hidden'
			>
				<div className='w-full px-4'>
					<TabsList className='w-full'>
						<TabsTrigger
							value='settings'
							data-testid='scenario-item-panel-settings-tab'
						>
							{t('settings')}
						</TabsTrigger>
						<TabsTrigger
							value='pricing_campaigns'
							data-testid='scenario-item-panel-pricing-campaigns-tab'
						>
							{t('pricing_campaigns')}
						</TabsTrigger>
					</TabsList>
				</div>

				<TabsContent
					value='settings'
					className='flex flex-col gap-2 overflow-y-hidden pt-2'
				>
					{panel.part === 'settings' && (
						<ScenarioSettingsTab scenarioId={panel.scenarioId!} />
					)}
				</TabsContent>
				<TabsContent
					value='pricing_campaigns'
					className='flex flex-col gap-2 overflow-y-hidden pt-2'
				>
					{panel.part === 'pricing_campaigns' && (
						<>
							<div className='w-full px-4'>
								<ScenarioPricingCampaignToolbar panel={panel} />
							</div>
							{panel.pricingCampaignId && (
								<ScenarioPricingCampaignTab
									pricingCampaignId={panel.pricingCampaignId}
								/>
							)}
						</>
					)}
				</TabsContent>
			</Tabs>
		)
	)
}
